export default {
      id: "list-usage",
      viewBox: "0 0 19 17",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#list",
      toString: function () {
        return this.url;
      }
    }